import { axios, Response } from '../index'
import { GroupUsers } from './list-group-users'

const getGroupUsersDetails = (groupId: number): Response<GroupUsers> => {
  return axios.get(`/v1/profiles/${groupId}`)
}

export default getGroupUsersDetails
